import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';
import Axios from 'axios';

import ProjectsList from '../Projects/ProjectsList';
import Btn from '../../components/Btn';


import '../../grid.css';
import './dashboard.css';


class ProjectsDashboard extends Component {
    componentDidMount() {
        const { authToken, setProjects, clientId } = this.props;
        const optionAxios = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
            },
        };
        Axios.get(`/v1/customer/projects/${clientId}`, optionAxios)
            .then((res) => {
                setProjects(res.data);
            }).catch((err) => {
                console.log(err);
            });
    }

    render() {
        const {
            projects, authToken, companyName, firstName,
            lastName, createProjectToken, projectToken, deleteProjectToken,
        } = this.props;

        if (!authToken) return <Redirect to="/" />;
        if (!projects) return <p>Loading... </p>;
        return (
            <div>
                <div className="row dashboard-content">
                    { companyName ?
                        <h1 className="dashboardTitle">{companyName} Projects</h1>
                        : <h1 className="dashboardTitle">{firstName} {lastName} Projects</h1>
                    }
                    <Btn className="navBtn addNewProjectBtn" label="Add New Project" to="/newproject" />
                    <div className="section">
                        {projectToken ? <p>{projectToken}</p> : null}
                        <div className="col span-12-of-12">
                            <ProjectsList
                                projects={projects}
                                authToken={authToken}
                                createProjectToken={createProjectToken}
                                projectToken={projectToken}
                                deleteProjectToken={deleteProjectToken}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ProjectsDashboard.propTypes = {
    projects: PropTypes.array,
    authToken: PropTypes.string.isRequired,
    companyName: PropTypes.string,
    setProjects: PropTypes.func.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    projectToken: PropTypes.string.isRequired,
    createProjectToken: PropTypes.func.isRequired,
    deleteProjectToken: PropTypes.func.isRequired,
    clientId: PropTypes.number.isRequired,
};

ProjectsDashboard.defaultProps = {
    projects: [],
    companyName: '',
};

export default ProjectsDashboard;



// WEBPACK FOOTER //
// ./src/containers/ProjectsDashboard/ProjectsDashboard.js